import React      from "react";
import List       from "../components/list";
import ListItem   from "../components/list-item";
import Spinner    from "../components/spinner";
import View       from "./view";
import messages   from "../../../messages";
import config     from "../../../config";
import Clinic     from "../components/clinic"

export default class BranchView extends View {
    static get title() {
        return "выберите филиал";
    }

    static get titleShort() {
        return "филиал";
    }

    static get propTypes() {
        return Object.assign({}, super.propTypes, {
            service: React.PropTypes.string,
            doctor: React.PropTypes.string,
        });
    }

    constructor (props) {
        super(props);

        this.state = Object.assign({}, this.state, {
            items: null
        });

        this._isMounted = false;
    }

    fetchData() {
        this.hideErrorMessage();
        this.setState({
            items: null,
        });

        let url = `${config.dataUrl}api.php?function=branches`;
        if (!!this.props.doctor){
            url += '&doctor='+this.props.doctor
        }

        fetch(url).then((response) => {
            return response.json();
        }).then((responseJson) => {
            if (this._isMounted === true) {
                if (responseJson.status === true) {
                    this.setState({
                        items: responseJson.clinics,
                    });
                } else {
                    this.showErrorMessage(responseJson.description);
                }
            }
        }).catch((error) => {
            if (this._isMounted === true) {
                this.showErrorMessage(messages["REQUEST_FAILED"]);
            }
        });
    }

    componentDidMount() {
        this.fetchData();
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleRetryClick() {
        this.fetchData();
    }

    renderContent() {
        if (this.state.isErrorMessageVisible === true) {
            return this.renderErrorMessage();
        }

        if (this.state.items === null) {
            return <Spinner />;
        }
        let nextView = "DateView";
        let viewProps = {};

        console.log(this.props);

        if (!!this.props.doctor) {
            viewProps = {doctor : this.props.doctor} ;
        }

        if (!!this.props.tag) {
            nextView = "DateView";
            viewProps = {tag : this.props.tag} ;
        }
        if (!this.props.service) {
            nextView = "ServiceView";
        }

        const elements = this.state.items.map((item, key) => {

            console.log('item branch', item);

            return (
                <ListItem key={key} isActive={true} onClick={() => {
                    this.props.gotoNextView({
                        breadcrumbName: item.name.toLowerCase(),
                        nextView: nextView,
                        props: {
                            clinic: parseInt(item.id, 10),
                            clinicInfo: 'info',
                            branchInfo: item,
                            ...viewProps,
                        }
                    });
                }}>
                    <Clinic
                        name={item.name}
                        address={item.address}
                        />
                </ListItem>
            );
        });

        return <List>{elements}</List>;
    }

    render() {
        return (
            <div className="appointment-view appointment-view--specialization">
                {this.renderContent()}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/branch.js
 **/